module.exports = __webpack_public_path__ + "static/media/guy-with-patoo.27c729e4.png";